import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

const fmt = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Kolkata" }) : "—");
const liveTime = (at) => (at ? fmt(/[zZ]|[+-]\d\d:\d\d$/.test(at) ? at : `${at}+05:30`) : "No time set");

// Admin: who clicked "Join now" for each live session.
export const Attendance = ({ api }) => {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.attendance().then(setRows).catch(() => setRows([])); }, [api]);
  if (rows === null) return <p className="p-6 text-sm text-slate-500">Loading…</p>;
  if (!rows.length) return <p className="p-8 text-center text-sm text-slate-500" data-testid="aiot-attendance-empty">No one has joined a live class yet. Attendance is recorded when an enrolled student clicks "Join now".</p>;
  return (
    <div className="divide-y divide-slate-100" data-testid="aiot-attendance">
      {rows.map((s) => {
        const key = `${s.class_id}@${s.live_at}`;
        const pct = s.enrolled ? Math.round((100 * s.attended) / s.enrolled) : 0;
        return (
          <div key={key}>
            <button type="button" onClick={() => setOpen(open === key ? null : key)} className="w-full px-4 py-3 flex flex-wrap items-center gap-4 text-left hover:bg-slate-50 transition-colors" data-testid={`aiot-attendance-row-${s.class_id}`}>
              <div className="flex-1 min-w-[220px]">
                <div className="font-bold text-[#0B1F3A] text-sm">Class {s.n}: {s.title}</div>
                <div className="text-xs text-slate-500">{liveTime(s.live_at)} IST</div>
              </div>
              <div className="w-40">
                <div className="h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full bg-[#14B8A6]" style={{ width: `${Math.min(pct, 100)}%` }} /></div>
                <div className="mt-1 text-xs font-bold text-[#0B1F3A]" data-testid={`aiot-attendance-count-${s.class_id}`}>{s.attended} of {s.enrolled} joined · {pct}%</div>
              </div>
              <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open === key ? "rotate-180" : ""}`} />
            </button>
            {open === key && (
              <table className="w-full text-sm bg-slate-50" data-testid={`aiot-attendance-list-${s.class_id}`}>
                <thead><tr className="text-left text-slate-600"><th className="px-4 py-2 font-semibold">Student</th><th className="px-4 py-2 font-semibold">Email</th><th className="px-4 py-2 font-semibold">First joined</th><th className="px-4 py-2 font-semibold">Clicks</th></tr></thead>
                <tbody>{s.students.map((st) => (
                  <tr key={st.email} className="border-t border-slate-200"><td className="px-4 py-2 font-semibold">{st.name || "—"}</td><td className="px-4 py-2">{st.email}</td><td className="px-4 py-2">{fmt(st.first_join_at)}</td><td className="px-4 py-2">{st.joins}</td></tr>
                ))}</tbody>
              </table>
            )}
          </div>
        );
      })}
    </div>
  );
};
